
export default {
    props: {
        steps: {
            type: Array,
            default: () => [],
        },
        active: {
            type: Object,
            default: null,
        },
        tooltip: {
            type: Function,
            default: () => null,
        },
        current: {
            type: Number,
            default: 0,
        },
        total: {
            type: Number,
            default: 0,
        },
        clickable: {
            type: Boolean,
            default: false,
        },
    },
}
